import { render, staticRenderFns } from "./multiChoiceItem.vue?vue&type=template&id=139b7d4e"
import script from "./multiChoiceItem.vue?vue&type=script&lang=js"
export * from "./multiChoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports